import {
  AUTH_LOGIN_USER,
  AUTH_LOGIN_USER_FAIL,
  AUTH_LOGIN_USER_SUCCESS,
  AUTH_LOGOUT_USER
} from "./types";

import { Dispatch } from "react";
import { database, auth, firebaseAuth } from "../../App";
import { authActionInterface } from "../reducers/AuthReducers";

export const setUser = () => (dispatch: Dispatch<authActionInterface>) => {
  dispatch({ type: AUTH_LOGIN_USER });

  auth.onAuthStateChanged(user => {
    if (user) {
      controlOnlineStatus(user);
      dispatch({ type: AUTH_LOGIN_USER_SUCCESS, user });
    } else {
      dispatch({ type: AUTH_LOGIN_USER_FAIL, user: undefined });
    }
  });
};

export const logoutUser = () => {
  return (dispatch: Dispatch<authActionInterface>) => {
    auth.signOut().then(() => {
      dispatch({ type: AUTH_LOGOUT_USER });
    });
  };
};

export const signInWithGoogle = () => (
  dispatch: Dispatch<authActionInterface>
) => {
  dispatch({ type: AUTH_LOGIN_USER });
  let provider = new firebaseAuth.GoogleAuthProvider();
  auth.setPersistence(firebaseAuth.Auth.Persistence.LOCAL).then(() => {
    auth
      .signInWithPopup(provider)
      .then(async function(result) {
        const user = result.user;
        if (user) {
          return dispatch({ type: AUTH_LOGIN_USER_SUCCESS, user });
        } else {
          return dispatch({ type: AUTH_LOGIN_USER_FAIL });
        }
      })
      .catch(() => {
        return dispatch({ type: AUTH_LOGIN_USER_FAIL });
      });
  });
};

function controlOnlineStatus(user: firebase.User) {
  database
    .ref("users")
    .child(user.uid)
    .child("profile")
    .update({ isOnline: true });
  database
    .ref("users")
    .child(user.uid)
    .child("profile")
    .onDisconnect()
    .update({ isOnline: false });
}
